import React, { useState, useEffect, useRef } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import API from "../../../utils/API";
import commonFunctions from "../../../utils/commonFunctions";

function ViewReceiverUsersModal(props) {
  const {
    receiverId,
    receiverName,
    setResetViewReceiverUsersModalRef,
  } = props;

  // Implemented multi-language support
  const intl = useIntl();
  const translation = (id) => intl.formatMessage({ id });

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const modalRef = useRef(null);
  const latestReceiverIdRef = useRef(receiverId);

  useEffect(() => {
    // Initialize the modal when component mounts
    const modalElement = document.getElementById('viewReceiverUsersModal');
    if (modalElement) {
      modalRef.current = new window.bootstrap.Modal(modalElement);
      
      // Add event listener for when modal is shown
      modalElement.addEventListener('show.bs.modal', handleModalShow);
      
      // Clean up
      return () => {
        modalElement.removeEventListener('show.bs.modal', handleModalShow);
        if (modalRef.current) {
          modalRef.current.dispose();
        }
      };
    }
  }, []);

  // Set up the reset function for the parent component
  useEffect(() => {
    if (setResetViewReceiverUsersModalRef) {
      setResetViewReceiverUsersModalRef(resetModal);
    }
  }, [setResetViewReceiverUsersModalRef]);

  const resetModal = (newReceiverId) => {
    setUsers([]);
    setError('');
    setLoading(false);
    
    // If new values are provided, use them
    if (newReceiverId) {
      // Store the values locally for the API call
      latestReceiverIdRef.current = newReceiverId;
    }
  };

  // Function to handle modal show event
  const handleModalShow = async () => {
    console.log("Modal show event triggered");
    resetModal(receiverId);
    
    // Get the latest receiverId from the ref
    const currentReceiverId = latestReceiverIdRef.current;
    console.log(`Current receiver ID in modal show: ${currentReceiverId}`);
    
    if (currentReceiverId) {
      console.log(`Loading users for receiver: ${currentReceiverId}`);
      setLoading(true);
      
      try {
        const response = await API.getSignageUsersByReceiver(latestReceiverIdRef.current);
        console.log('signage users data received:', response.data);
        setUsers(response.data);
      } catch (err) {
        console.error(`Failed to load users for receiver: ${err}`);
        setError(translation('LOAD_USERS_FAILED'));
      } finally {
        setLoading(false);
      }
    } else {
      console.warn("No receiver ID provided");
    }
  };

  // Update the ref whenever receiverId changes
  useEffect(() => {
    latestReceiverIdRef.current = receiverId;
    console.log(`Receiver ID updated in ref: ${latestReceiverIdRef.current}`);
  }, [receiverId]);

  // Update modal when receiver changes
  useEffect(() => {
    if (receiverId && modalRef.current) {
      console.log(`Receiver ID updated to: ${receiverId}`);
      // If the modal is already open, refresh the data
      const modalElement = document.getElementById('viewReceiverUsersModal');
      if (modalElement.classList.contains('show')) {
        handleModalShow();
      }
    }
  }, [receiverId]);

  return (
    <div className="modal modal-mse fade" id="viewReceiverUsersModal" tabIndex="-1" aria-labelledby="viewReceiverUsersModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content modal-mes-content">
          <div className="modal-header modal-mes-header" style={{ backgroundColor: '#347BFA' }}>
            <h5 className="modal-title modal-mes-title">
              <FormattedMessage id="USERS_IN_RECEIVER" /> {receiverName && `: ${receiverName}`}
            </h5>
            <button id="closeViewReceiverUsersModal" type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <div className="card" style={{ borderRadius: '8px', overflow: 'hidden' }}>
              <div style={{ overflowX: 'hidden' }}>
                <table className="table">
                  <thead>
                    <tr style={{ backgroundColor: '#E9F3FC' }}>
                      <th className="mesCustomHeaderCell"><FormattedMessage id="FIRST_NAME" /></th>
                      <th className="mesCustomHeaderCell"><FormattedMessage id="LAST_NAME" /></th>
                      <th className="mesCustomHeaderCell"><FormattedMessage id="EMAIL" /></th>
                    </tr>
                  </thead>
                  <tbody>
                    {users && users.length > 0 ? (
                      users.map((user) => (
                        <tr key={user.id}>
                          <td className="mesCustomBodyCell">{user.firstName}</td>
                          <td className="mesCustomBodyCell">{user.lastName}</td>
                          <td className="mesCustomBodyCell">{user.email}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3" className="text-center mesCustomBodyCell">
                          <FormattedMessage id="NO_USERS_IN_RECEIVER" />
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            {error && (
              <div className="modal-error invalid-feedback d-block fw-bold text-center">
                {error}
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-primary but-darkblue" data-bs-dismiss="modal">
              <FormattedMessage id="CLOSE" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewReceiverUsersModal;  